import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/login/groupImg2.svg'
import _imports_1 from '../../assets/login/groupImg.svg'
import _imports_2 from '@/assets/login/logoparent.svg'
import _imports_3 from '../../assets/login/title.svg'
import _imports_4 from '@/components/nav/component/img/logoparent.svg'
import _imports_5 from '@/components/nav/component/img/logo.svg'
import _imports_6 from '@/assets/login/googleLogo.svg'
import _imports_7 from '@/assets/login/google-loading.png'


const _withScopeId = n => (_pushScopeId("data-v-58b52b66"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  src: _imports_0,
  class: "left-img",
  alt: "",
  srcset: ""
}
const _hoisted_2 = {
  key: 1,
  src: _imports_1,
  class: "left-img",
  alt: "",
  srcset: ""
}
const _hoisted_3 = {
  key: 0,
  class: "mobileLogo"
}
const _hoisted_4 = { class: "title" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_6,
  class: "googleLogo"
}, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_7,
  class: "googleLogo rotateGoogle"
}, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "or" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line1" }, null, -1))
const _hoisted_10 = { class: "text" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line2" }, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "left-style backEmi",
  autocomplete: "auto"
}, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "left-style backPass",
  autocomplete: "auto"
}, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "custom-loading" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "circular",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      opacity: "0.2",
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM1.45459 8.00014C1.45459 11.6151 4.38509 14.5456 8.00004 14.5456C11.615 14.5456 14.5455 11.6151 14.5455 8.00014C14.5455 4.38519 11.615 1.45469 8.00004 1.45469C4.38509 1.45469 1.45459 4.38519 1.45459 8.00014Z",
      fill: "white"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16V14.5455C4.38505 14.5455 1.45455 11.615 1.45455 8C1.45455 4.38505 4.38505 1.45455 8 1.45455V0Z",
      fill: "white"
    })
  ])
], -1))
const _hoisted_15 = { class: "goLogIn" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_languageChange = _resolveComponent("languageChange")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_loadingChat = _resolveComponent("loadingChat")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createBlock(_component_el_row, {
    type: "flex",
    class: _normalizeClass(["loginBox", _ctx.equipmentType ? 'mobileRow' : ''])
  }, {
    default: _withCtx(() => [
      (!_ctx.equipmentType)
        ? (_openBlock(), _createBlock(_component_el_col, {
            key: 0,
            xs: 0,
            sm: 10,
            md: 10,
            lg: 10,
            xl: 9,
            style: {"position":"relative","overflow":"hidden"}
          }, {
            default: _withCtx(() => [
              (_ctx.originUrl)
                ? (_openBlock(), _createElementBlock("img", _hoisted_1))
                : (_openBlock(), _createElementBlock("img", _hoisted_2)),
              (_ctx.originUrl)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 2,
                    src: _imports_2,
                    class: "logos",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.homePage && _ctx.homePage(...args))),
                    alt: "官网",
                    srcset: ""
                  }))
                : (_openBlock(), _createElementBlock("img", {
                    key: 3,
                    src: _imports_3,
                    class: "logos",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.homePage && _ctx.homePage(...args))),
                    alt: "官网",
                    srcset: ""
                  }))
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_el_col, {
        xs: 24,
        sm: 14,
        md: 14,
        lg: 14,
        xl: 15,
        style: {"background-color":"#ffffff"},
        class: "signInput"
      }, {
        default: _withCtx(() => [
          (!_ctx.formData.googleRedirect)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["Login", _ctx.equipmentType ? 'mobildLogin' : ''])
              }, [
                (_ctx.equipmentType)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      (_ctx.originUrl)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: _imports_4,
                            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.homePage && _ctx.homePage(...args)))
                          }))
                        : (_openBlock(), _createElementBlock("img", {
                            key: 1,
                            src: _imports_5,
                            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.homePage && _ctx.homePage(...args)))
                          })),
                      _createVNode(_component_languageChange, {
                        send: _ctx.senMsg,
                        id: "logoImg",
                        class: "mobileLang"
                      }, null, 8, ["send"])
                    ]))
                  : _createCommentVNode("", true),
                (!_ctx.equipmentType)
                  ? (_openBlock(), _createBlock(_component_languageChange, {
                      key: 1,
                      send: _ctx.senMsg
                    }, null, 8, ["send"]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", {
                  class: _normalizeClass(["box", _ctx.equipmentType ? 'mobildBox' : ''])
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["section", _ctx.equipmentType ? 'removeBorder' : ''])
                  }, [
                    _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t("signIn")), 1),
                    (!_ctx.formData.isGoogleSign)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "loginButton",
                          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.goGoole && _ctx.goGoole(...args)))
                        }, [
                          _hoisted_5,
                          _createElementVNode("span", null, _toDisplayString(_ctx.$t("famikeep222.Continue Google")), 1)
                        ]))
                      : (_openBlock(), _createElementBlock("div", {
                          key: 1,
                          class: "loginButton",
                          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.goGoole && _ctx.goGoole(...args)))
                        }, _hoisted_7)),
                    _createElementVNode("div", _hoisted_8, [
                      _hoisted_9,
                      _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t("famikeep222.or")), 1),
                      _hoisted_11
                    ]),
                    _createVNode(_component_el_form, {
                      class: _normalizeClass(["apply-form first-form", _ctx.equipmentType ? 'mobileApply' : '']),
                      model: _ctx.formData,
                      rules: _ctx.emailRule,
                      ref: "ruleFormRef",
                      "inline-message": "true",
                      "scroll-to-error": "true"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          label: "",
                          prop: "UserName"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_12,
                            _createVNode(_component_el_input, {
                              placeholder: _ctx.$t('email'),
                              modelValue: _ctx.formData.UserName,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.UserName) = $event)),
                              onInput: _ctx.UserNameTrim,
                              class: "setlist",
                              "validate-event": false,
                              ref: "userNameRef",
                              id: "userNameRef"
                            }, null, 8, ["placeholder", "modelValue", "onInput"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, {
                          label: "",
                          prop: "UserPassword",
                          class: "pass"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_13,
                            _createVNode(_component_el_input, {
                              style: {"position":"relative"},
                              placeholder: _ctx.$t('password'),
                              modelValue: _ctx.formData.UserPassword,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.UserPassword) = $event)),
                              type: _ctx.formData.isShowPassword ? 'text' : 'password',
                              onInput: _ctx.UserPasswordTrim,
                              autocomplete: _ctx.store.state.isLoginExpired ? 'new-password' : '',
                              "validate-event": false
                            }, null, 8, ["placeholder", "modelValue", "type", "onInput", "autocomplete"]),
                            _createElementVNode("div", {
                              class: _normalizeClass(["eye-style", [_ctx.formData.isShowPassword ? 'uneye' : 'eyes']]),
                              autocomplete: "auto",
                              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.formData.isShowPassword = !_ctx.formData.isShowPassword))
                            }, null, 2)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["model", "rules", "class"]),
                    (_ctx.formData.isSignIn)
                      ? (_openBlock(), _createBlock(_component_el_button, {
                          key: 2,
                          class: _normalizeClass(_ctx.formData.isOk ? 'signUpButton' : 'unsignUpButton'),
                          type: "primary",
                          onClick: _ctx.signIn,
                          round: ""
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("signIn")), 1)
                          ]),
                          _: 1
                        }, 8, ["class", "onClick"]))
                      : (_openBlock(), _createBlock(_component_el_button, {
                          key: 3,
                          class: _normalizeClass(_ctx.formData.isOk ? 'signUpButton' : 'unsignUpButton'),
                          type: "primary",
                          onClick: _ctx.signIn,
                          round: "",
                          loading: ""
                        }, {
                          loading: _withCtx(() => [
                            _hoisted_14
                          ]),
                          default: _withCtx(() => [
                            _createTextVNode(" " + _toDisplayString(_ctx.$t("signingIn")), 1)
                          ]),
                          _: 1
                        }, 8, ["class", "onClick"])),
                    _createElementVNode("div", {
                      class: _normalizeClass(["bottomBox", _ctx.equipmentType ? 'mobileLayout' : ''])
                    }, [
                      _createElementVNode("div", _hoisted_15, [
                        _createTextVNode(_toDisplayString(_ctx.$t("noAccount")) + " ", 1),
                        _createElementVNode("span", {
                          class: "goLogInButton",
                          onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.goRegister && _ctx.goRegister(...args)))
                        }, _toDisplayString(_ctx.$t("signUpNow")), 1)
                      ]),
                      (!_ctx.equipmentType)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "goReset",
                            onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.goReset && _ctx.goReset(...args)))
                          }, _toDisplayString(_ctx.$t("forgetPassword")), 1))
                        : _createCommentVNode("", true)
                    ], 2)
                  ], 2)
                ], 2),
                (_ctx.equipmentType)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 2,
                      class: _normalizeClass(["goReset", _ctx.equipmentType ? 'mobileForget' : '']),
                      onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.goReset && _ctx.goReset(...args)))
                    }, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t("forgetPassword")), 1)
                    ], 2))
                  : _createCommentVNode("", true)
              ], 2))
            : (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: _normalizeClass(["Login", _ctx.equipmentType ? 'mobildLogin' : ''])
              }, [
                _createVNode(_component_loadingChat, { class: "locationLoading" })
              ], 2))
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["class"]))
}